import React from "react";
import { Link } from "react-router";
import { merge, $ } from "glamor";
import { themeOptions } from "styles/theme";
import { NAV } from "constants/integration/navigation";

const styles = merge(
    $(" a", {
        fontSize: "11px",
        color: themeOptions.palette.darkGrey,
    }),
);

interface IBreadcrumbProps {
    breadcrumbs: Array<{ url: string; title: string; dataTest?: string }>;
    crumbsStyles?: object;
    className?: string;
}

export const Breadcrumbs: React.FunctionComponent<IBreadcrumbProps> = ({
    breadcrumbs,
    className,
    crumbsStyles = {},
}) => {
    if (!breadcrumbs || !Array.isArray(breadcrumbs)) {
        return null;
    }
    return (
        <div {...styles} {...crumbsStyles} className={className} data-test={NAV.BREADCRUMBS}>
            {breadcrumbs.map(({ url, title, dataTest }, idx) => (
                <Link data-test={dataTest} key={idx} to={url}>
                    {`${title} ${idx < breadcrumbs.length - 1 ? "> " : ""}`}
                </Link>
            ))}
        </div>
    );
};
